/**
 * misc 分包 i18n：进入 misc 业务页面前 merge 全量业务文案（方案 B 集中维护）。
 *
 * @module misc/i18n/ensure-locales
 */

import i18n from '@/locale/index'

import activityEn from './activity/en'
import activityZhHans from './activity/zh-Hans'
import combinedOrderEn from './combinedOrder/en'
import combinedOrderZhHans from './combinedOrder/zh-Hans'
import orderDetailEn from './orderDetail/en'
import orderDetailZhHans from './orderDetail/zh-Hans'
import orderEn from './order/en'
import orderZhHans from './order/zh-Hans'
import hotelEn from './hotel/en'
import hotelZhHans from './hotel/zh-Hans'
import insuranceEn from './insurance/en'
import insuranceZhHans from './insurance/zh-Hans'
import planeEn from './plane/en'
import planeZhHans from './plane/zh-Hans'
import tourismEn from './tourism/en'
import tourismZhHans from './tourism/zh-Hans'
import trainEn from './train/en'
import trainZhHans from './train/zh-Hans'
import miscEn from './en'
import miscZhHans from './zh-Hans'

let merged = false

/** 将 misc 分包全部业务文案合并进全局 i18n（幂等，仅执行一次） */
export function ensureMiscLocales(): void {
  if (merged)
    return
  merged = true
  i18n.global.mergeLocaleMessage('zh-Hans', miscZhHans)
  i18n.global.mergeLocaleMessage('en', miscEn)
  i18n.global.mergeLocaleMessage('zh-Hans', hotelZhHans)
  i18n.global.mergeLocaleMessage('en', hotelEn)
  i18n.global.mergeLocaleMessage('zh-Hans', insuranceZhHans)
  i18n.global.mergeLocaleMessage('en', insuranceEn)
  i18n.global.mergeLocaleMessage('zh-Hans', trainZhHans)
  i18n.global.mergeLocaleMessage('en', trainEn)
  i18n.global.mergeLocaleMessage('zh-Hans', planeZhHans)
  i18n.global.mergeLocaleMessage('en', planeEn)
  i18n.global.mergeLocaleMessage('zh-Hans', tourismZhHans)
  i18n.global.mergeLocaleMessage('en', tourismEn)
  i18n.global.mergeLocaleMessage('zh-Hans', activityZhHans)
  i18n.global.mergeLocaleMessage('en', activityEn)
  i18n.global.mergeLocaleMessage('zh-Hans', combinedOrderZhHans)
  i18n.global.mergeLocaleMessage('en', combinedOrderEn)
  i18n.global.mergeLocaleMessage('zh-Hans', orderDetailZhHans)
  i18n.global.mergeLocaleMessage('en', orderDetailEn)
  i18n.global.mergeLocaleMessage('zh-Hans', orderZhHans)
  i18n.global.mergeLocaleMessage('en', orderEn)
}
